import IconWrapper from "@components/svg_icon_wrapper"

export default function HomeOutlined() {
  return (
    <IconWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19.477"
        height="19.008"
        viewBox="0 0 25.477 25.008"
      >
        <g id="Group_8786" data-name="Group 8786" transform="translate(0 0)">
          <path
            id="Path_95"
            data-name="Path 95"
            d="M913.639,220.355h-4.648c0,.285,0,.542,0,.8.005,2.346.015,4.691.014,7.037,0,1.007-.4,1.418-1.4,1.421q-3.809.01-7.617,0c-.962,0-1.394-.412-1.4-1.362-.01-4.522-.02-9.044.023-13.565a1.764,1.764,0,0,1,.61-1.213c3.737-2.873,7.509-5.7,11.269-8.544a1.238,1.238,0,0,1,1.655,0c3.76,2.843,7.533,5.669,11.269,8.543a1.766,1.766,0,0,1,.611,1.213c.043,4.522.033,9.044.023,13.566,0,.955-.432,1.363-1.392,1.365q-3.808.011-7.617,0c-1,0-1.4-.412-1.4-1.418C913.635,225.608,913.639,223.023,913.639,220.355Zm-6.951,6.913c0-.325,0-.586,0-.847q-.008-3.481-.014-6.963c0-1.051.395-1.451,1.438-1.454q3.155-.008,6.31,0c1.15,0,1.531.375,1.533,1.512q.006,3.482,0,6.963v.767h5.785v-.757c0-3.578-.011-7.156.012-10.735a1.248,1.248,0,0,0-.584-1.131c-3.119-2.326-6.22-4.677-9.328-7.019-.17-.128-.35-.243-.545-.377-3.379,2.55-6.74,5.075-10.078,7.629a1.14,1.14,0,0,0-.3.81c-.02,3.651-.014,7.3-.011,10.952,0,.21.028.419.044.65Z"
            transform="translate(-898.585 -204.607)"
            fill="#fff"
          />
        </g>
      </svg>
    </IconWrapper>
  )
}
